import React from 'react'
import { modalActions } from './modal'

const UPDATE_NOTICE = {
  heading: 'We’re making some special updates!',
  content: <div>On <b>November 15th</b>, our servers will be down for basic system maintenance at <b>6 - 8 AM EST</b> (for North America) and <b>10 PM - 12 PM GMT</b> (for Europe). Any pending submissions will be automatically updated following the maintenance period. If you have any questions, please contact support at <a href='mailto:linkt@stefanini.com'>linkt@stefanini.com</a>.</div>,
}

const openNotice = (modalProps) => {
  return dispatch => {
    const { LANDING_MESSAGE_ENABLED } = process.env
    if (LANDING_MESSAGE_ENABLED === 'NO') return;

    const {
      cancelButton,
      children,
      className,
      closeModal,
      closeOnBackgroundClick,
      closeX,
      confirmButton,
      confirmButtonExtraText,
      content,
      happyHumi,
      heading,
      height,
      humi,
      noButtons,
      onCancel,
      onConfirm,
      open,
      width,
    } = modalProps

    dispatch(modalActions.openModal({
      className,
      noButtons,
      heading: UPDATE_NOTICE.heading,
      content: UPDATE_NOTICE.content,
      closeOnBackgroundClick,
      humi,
      happyHumi,
      closeX,
    }))
  }
}

export const noticeActions = {
  openNotice,
}


// WEBPACK FOOTER //
// ./src/store/notice.js